export const SITE = {
  name: "CATHRYN",
  role: "Hair Artist",
  city: "Hermosa Beach, CA",
  addressLine: "934 Hermosa Ave · Suite 6",
  postalAddress: {
    streetAddress: "934 Hermosa Ave, Suite 6",
    addressLocality: "Hermosa Beach",
    addressRegion: "CA",
    postalCode: "90254",
    addressCountry: "US",
  },
  latitude: 33.86025,
  longitude: -118.39941,

  phone: "(949) 228-8554",
  phoneHref: "+19492288554",

  bookingUrl: "https://mysite.vagaro.com/truebeauty4/book-now",

  instagram: "@catstrubeauty",

  instagramHref: "https://www.instagram.com/catstrubeauty/",
  openingHours: ["Tu 10:00-18:00", "We 10:00-18:00", "Th 10:00-18:00", "Fr 10:00-18:00", "Sa 10:00-16:00"],
  mapEmbedUrl(markerLat: number, markerLon: number): string {
    // ~0.6-mile box around the studio so the marker is comfortably centered.
    const padLat = 0.0055;
    const padLon = 0.0055;
    const minLon = markerLon - padLon;
    const minLat = markerLat - padLat;
    const maxLon = markerLon + padLon;
    const maxLat = markerLat + padLat;
    const params = new URLSearchParams({
      bbox: `${minLon},${minLat},${maxLon},${maxLat}`,
      layer: "mapnik",
      marker: `${markerLat},${markerLon}`,
    });
    return `https://www.openstreetmap.org/export/embed.html?${params.toString()}`;
  },
  get mapEmbed(): string {
    return this.mapEmbedUrl(this.latitude, this.longitude);
  },
  get mapHref(): string {
    const params = new URLSearchParams({
      mlat: String(this.latitude),
      mlon: String(this.longitude),
    });
    return `https://www.openstreetmap.org/?${params.toString()}#map=17/${this.latitude}/${this.longitude}`;
  },
  booking: {
    defaultService: "Not specified",
    defaultMessage: "—",
  },
} as const;
